/**
 * 描述：弹窗内部局部滚动阴影添加
 * 日期：2018-4-17
 * 作者：gao.kaizhi
 */
'use strict';
angular.module('btOpacityModule', []).
directive('btOpacity', ["$timeout", function($timeout) {
    return {
        restrict: 'C',
        replace: false,
        link: function(scope, $elem, $attrs) {
            init();
            /**
             * [init description] 初始化
             * @return {[type]} [description]
             */
            function init() {
                $timeout(function() {
                    if ($elem.css("overflow-y") == "auto") {
                        setopacity();
                    } else {
                        $elem.find('+ .selfooter').css("display", "none");
                    }
                }, 800);

                function setopacity() {                   
                    $timeout(function() {                                               
                        if ($elem.height() >= $elem.find(".innerScr").height()) {
                            $elem.find('+ .selfooter').css("display", "none");
                        } else {
                            $elem.find('+ .selfooter').css("display", "block");
                        }
                    }, 300);
                    $elem.scroll(function() {
                        var q = $elem.scrollTop();
                        var bodyH = $elem.height();
                        var innerH = $elem.find(".innerScr").height();
                        if (Math.floor(innerH) <= Math.floor(q + bodyH + 10)) {
                            $elem.find('+ .selfooter').css("display", "none");
                        } else {
                            $elem.find('+ .selfooter').css("display", "block");
                        }
                    });
                }
            }

            scope.$on('btOpacityBroadcast', function (event, data) {
                init();
            });
        }
    };
}]);